export const AUDIT_SETTLEMENTS_REPORT_LOADINGS = {
  GET_REPORT: "loadingAuditSettlementsReport"
};

export const reportAuditSettlementsTypes = {
  SET_AUDIT_SETTLEMENTS_REPORT_FILTERS: "AUDIT_SETTLEMENTS_REPORT/SET_FILTERS",
  RESTORE_INITIAL: "AUDIT_SETTLEMENTS_REPORT/RESTORE_INITIAL",
};
